<template>
  <div>
    <van-address-list
      v-model="chosenAddressId"
      :list="list"
      default-tag-text="默认"
      @add="onAdd"
      @edit="onEdit"
      @select="clickItem"
    />

    <Floating />
    <wxNoShare />
  </div>
</template>

<script>
  import { AddressList } from 'vant';

  export default {
    components: {
      [AddressList.name]: AddressList,
    },
    name: 'user-address',
    data() {
      return {
        chosenAddressId: 0,
        list: []
      };
    },
    created() {
      this.addressList()
    },
    methods: {
      onAdd() {
        this.$router.push({name:'addressAddEdit'})
      },
      onEdit(item, index) {
        this.$router.push({name:'addressAddEdit', query:{id:item.id}})
      },
      clickItem(item, index) {
        this.$api.post('address/status', {'id':item.id}, r=>{
          if(r.success == 1){
            this.$toast('设置默认地址成功')
            this.addressList()
          }
        })
      },
      addressList() {
        this.$api.get('address', null, r=>{
          this.list = r.data
          for(let i=0; i<r.data.length; i++){
            if(r.data[i].isDefault){
              this.chosenAddressId = r.data[i].id
            }
          }
        })
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/users/address.vue